const ENConsultValuesFinancialManagement = {
	"Adicionar DRE": "Add income statement",
	"Adicione códigos de integração para": "Add integration codes to",
	"Adicionar indicador Total": "Add indicator Total",
	"Adicionar linha": "Add line",
	"Adicionar linha do demonstrativo": "Add statement line",
	"Adicionar valor": "Add value",
	"Alterar DRE": "Change income statement",
	"Alterar itens": "Change itens",
	"Alterar linha do demonstrativo": "Change statement line",
	"Alterar valores": "Change values",
	"Alterar o valor atual": "Change the current value",
	"Alterar tipo do demonstrativo": "Change type of statement",
	"Alterar tipo": "Change type",
	"Anterior": "Previous",
	"Ano anterior": "Last year",
	"Aplicar percentual ao valor atual": "Apply percentage to current value",
	"Atualizar indicadores": "Update indicators",
	"Atualizar valores corporativos": "Update corporative values",
	"A.H. Anterior": "H.A. Last year",
	"A.V. Anterior": "V.A. Last year",
	"A.H. Plan": "H.A. Plan",
	"A.V. Plan": "V.A. Plan",
	"A.H. Real": "H.A. Accomp",
	"A.V. Real": "V.A. Accomp",
	"Base Análise Vertical": "Vertical Analysis Base",
	"Base para análise vertical": "Base for vertical analysis",
	"Cada arquivo poderá conter no máximo 20Mb de tamanho": "Each file can contain a maximum of 20Mb in size",
	"Canal de venda": "Sales channel",
	"Canais de venda": "Sales channel",
	"Centro de custo": "Cost center",
	"Centro de custo corporativo": "Corporative cost center",
	"Códigos de integração adicionados com sucesso": "Integrations code successfully added",
	"Composição de valores": "Values composition",
	"Composição de valores atualizados com sucesso": "Update values successfully updated",
	"Com rateio": "With apportionment",
	"Configurações atualizadas com sucesso": "Settings successfully updated",
	"Conta": "Account",
	"Consulta valores de orçamento": "Query budget values",
	"Copiar ano anterior": "Copy last year",
	"Copiar demonstrativo": "Copy statement",
	"Custos variáveis": "Variable costs",
	"Deduções de vendas": "Sales deductions",
	"Demonstrativo": "Statement",
	"Demonstrativos": "Statements",
	"Demonstrativo adicionado com sucesso": "Statement successfully added",
	"Demonstrativo alterado com sucesso":  "Statement successfully changed",
	"Demonstrativo copiado, você pode alterá-lo agora": "Statement copied, you can change it now",
	"Demonstrativo excluído com sucesso": "Statement successfully deleted",
	"Demonstrativo não encontrado": "Statement not found",
	"Demonstrativo resultado do exercício": "Income statement for the year",
	"Deseja realmente adicionar": "Do you really want to add",
	"Deseja realmente alterar o tipo deste demonstrativo": "Do you really want to change the type of this statement",
	"Deseja realmente copiar este demonstrativo": "Do you really want to copy this statement",
	"Deseja realmente excluir as permissões": "Do you really want to delete the permissions",
	"Deseja realmente excluir este demonstrativo": "Do you really want to delete this statement",
	"Deseja realmente excluir esta linha do demonstrativo": "Do you really want to delete this line from the statement",
	"Despesas operacionais": "Operational expenses",
	"Despesas variáveis": "Variable expenses",
	"Destaca linha": "Highlight line",
	"Divisor dos períodos": "Periods divider",
	"Divisor dos valores": "Values divider",
	"Drilldown atualizado com sucesso": "Drilldown successfully updated",
	"DRE": "Income statement",
	"É necessário ao menos um arquivo para importar": "At least one file is required to import",
	"Erro ao adicionar demonstrativo": "Error adding statement",
	"Erro ao adicionar linha do demonstrativo": "Error adding statement row",
	"Erro ao alterar linha do demonstrativo": "Error changing statement row",
	"Erro ao adicionar link": "Error adding link",
	"Erro ao adicionar valores": "Error adding values",
	"Erro ao alterar a conta": "Error changing account",
	"Erro ao alterar demonstrativo": "Error changing statement",
	"Erro ao atualizar composição de valores": "Error updating values",
	"Erro ao atualizar drilldown da linha do demonstrativo": "Error updating drilldown of statement row",
	"Erro ao atualizar valores corporativos": "Error updating corporate values",
	"Erro ao buscar configurações": "Error searching configurations",
	"Erro ao buscar demonstrativo": "Error searching for statement",
	"Erro ao buscar drilldown da linha do demonstrativo": "Error fetching drilldown from statement row",
	"Erro ao buscar linha do demonstrativo": "Error searching for statement row",
	"Erro ao buscar linhas do demonstrativo": "Error searching for statement rows",
	"Erro ao buscar composição de valores da linha do demonstrativo": "Error fetching composition of statement line values",
	"Erro ao copiar demonstrativo": "Error copying statement",
	"Erro ao exportar estrutura valores": "Error exporting structure values",
	"Erro ao excluir demonstrativo": "Error deleting statement",
	"Erro ao excluir linha do demonstrativo": "Error deleting statement line",
	"Erro ao excluir o item": "Error deleting the item",
	"Erro ao importar estrutura valores": "Error importing structure values",
	"Erro ao reordenar linhas": "Error reordering lines",
	"Erro ao salvar códigos de integração": "Error saving integration code",
	"Erro ao salvar rateios": "Error saving apportionment",
	"Erro ao salvar Unidade/Filial": "Error saving unit/subsidiary",
	"Estrutura": "Structure",
	"Estrutura exportada com sucesso": "Structure exported successfully",
	"Estrutura importada com sucesso": "Structure imported successfully",
	"Esse processo pode demorar alguns minutos, deseja continuar": "This process may take a while, do you want to continue",
	"Excluir DRE": "Delete income statement",
	"Excluir linha do demonstrativo": "Delete statement line",
	"Excluir todos": "Delete all",
	"Existem períodos em que não foi cadastrado a conversão da moeda": "There are periods in which the currency conversion was not registered",
	"Exportar apenas linhas com valores": "Export only lines with values",
	"Exportar estrutura": "Export structure",
	"Exportar estrutura delimitada": "Export delimited structure",
	"Exportar estrutura do orçamento": "Export budget structure",
	"Exportar valores": "Export values",
	"Gerenciar indicadores": "Manage indicators",
	"Gestão orçamentária": "Financial management",
	"Gestão Orçamentária": "Financial Management",
	"Impostos sobre lucro": "Income Taxes",
	"Importar estrutura": "Import structure",
	"Informa planejado": "Inform planned",
	"Informa quantidade": "Inform quantity",
	"Informa valor": "Inform value",
	"Importar valores": "Import values",
	"Link adicionado com sucesso": "Link successfully added",
	"Linha de produto": "Product line",
	"Linhas do demonstrativo": "Statement lines",
	"Linha do demonstrativo alterado com sucesso": "Statement line successfully added",
	"Linha do demonstrativo excluída com sucesso": "Statement line successfully deleted",
	"Listar itens": "List itens",
	"Média ano anterior": "Avarege last year",
	"Moeda planejado": "Planned coin",
	"Moeda realizado": "Realized coin",
	"Mostrar hierarquia": "Show hierarchy",
	"Mostrar linha": "Show line",
	"Mostrar períodos": "Show periods",
	"Mostrar nível inferior": "Show lower level",
	"Mostrar nível inferior do agrupador": "Show lower level of grouper",
	"Não há valores para exportar": "There is no value to export",
	"Não pode exportar um período maior que um ano": "Cannot export a period longer than one year",
	"Não utilize cabeçalhos e linhas em branco": "Don't use header or blank lines",
	"Nenhum código de integração adicionado": "No integration code added",
	"Nenhum plano orçamentário selecionado": "No budget plan selected",
	"Nenhum valor adicionado": "No value added",
	"Nenhum valor para hierarquia (drill down) encontrado": "No value for hierarchy (drill down) found",
	"Outras contas": "Other accounts",
	"Outras despesas": "Other expenses",
	"Percentual de dedução de vendas não pode ultrapassar 1000": "Sales deduction percentage cannot exceed 1000",
	"Percentual de despesas variáveis não pode ultrapassar 1000": "Variable expenses percentage cannot exceed 1000",
	"Planejado": "Planned",
	"Planejado x Ano anterior": "Planned x Last year",
	"Planejado e Realizado": "Planned and Accomplished",
	"Planejado x Realizado": "Planned x Accomplished",
	"Planos orçamentários": "Budget plans",
	"Plano orçamentário não encontrado": "Budget plan not found",
	"Preço unitário": "Unit price",
	"Produto/Serviço": "Product/Service",
	"Produto/serviço": "Product/service",
	"Popular valores planejados": "Populate planned values",
	"Quantidade": "Quantity",
	"Qtde": "Qty",
	"Rateios adicionados com sucesso": "Apportionment successfully added",
	"Rateio de centro de custo": "Cost center apportionment",
	"Rateio C.Custo": "Cost c. apportionment",
	"Realizado x Ano anterior": "Accomplished x Last year",
	"Receita de vendas": "Sales revenue",
	"Selecione uma opção para carregar a hierarquia": "Select an option to load the hierarchy",
	"Sem rateio": "Without apportionment",
	"Somar o valor atual": "Sum the current value",
	"Somente com valores": "Only with values",
	"Somente com valores informados": "Only with informed values",
	"Tipo de rateio": "Apportionment type",
	"Todos os itens": "All itens",
	"Todos os itens da linha já existem": "All itens of line already exists",
	"Unidade/Filial": "Unit/Subsidiary",
	"Unidades/Filiais": "Units/Subsidiarys",
	"Unidade/Filial adicionada com sucesso": "Unit/Subsidiary successfully added",
	"Unidade/Filial alterada com sucesso": "Unit/Subsidiary successfully changed",
	"Unidade/Filial não selecionada": "Unit/Subsidiary not selected",
	"Utilize as permissões para definir a unidade/filial/usuário/grupo de usuários e sua permissão diretamente na hierarquia": "Use permissions to set the unit/subsidiary/user/user group and their permission directly in the hierarchy",
	"Utilize o arquivo gerado na exportação da Estrutura do Orçamento": "Use the file generated in the Budget Structure export",
	"Utiliza rateio de Centro de custo": "Uses cost center apportionment",
	"Valores adicionados com sucesso": "Values successfully added",
	"Valores corporativos": "Corporative values",
	"Valores corporativos atualizados com sucesso": "Corporate values ​​successfully updated",
	"Valor total deve ser igual a 100": "Total value must be equal 100",
	"Variação": "Variation",
	"Você está tentando inserir valores corporativos sendo que a unidade/filial corporativa não é a selecionada": "You are trying to enter corporate values ​​when the corporate unit/subsidiary is not selected",
	"Você não tem permissão para a hierarquia solicitada": "You do not have permission for the requested hierarchy",
	"Você pode utilizar arquivos nas extensões (.txt, .csv, .xls, .xlsx ou .ods)": "You can use files with extensions (.txt, .csv, .xls, .xlsx or .ods)"
};

export default ENConsultValuesFinancialManagement;
